import * as React from "react";
import styles from "./footer.module.scss";

const logo = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/logo_1.png";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.left}>
          <img src={logo} alt="" />
          <p>© Ceroface</p>
        </div>

        <div>
          <ul>
            <LineItem popup="Your package will be sent out the day of ordering.<br />Shipping time: 6-9 working days.">
              Shipping
            </LineItem>
            <LineItem href="https://ceroface.com/policies/privacy-policy">
              Policy & Cookies
            </LineItem>
            <LineItem href="https://ceroface.com/policies/terms-of-service">Terms and conditions</LineItem>
          </ul>
        </div>
      </div>
    </footer>
  );
};

const LineItem = ({
  children,
  popup,
  href
}: {
  children: string;
  popup?: string;
  href?: string
}) => {
  const [showPopup, togglePopup] = React.useState();

  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <div
        className={styles.lineItem}
        onMouseEnter={() => togglePopup(true)}
        onMouseLeave={() => togglePopup(false)}
      >
        {showPopup && popup && (
          <div
            className={styles.popup}
            dangerouslySetInnerHTML={{ __html: popup }}
          />
        )}
        <li>{children}</li>
      </div>
    </a>
  ) : (
    <div
      className={styles.lineItem}
      onMouseEnter={() => togglePopup(true)}
      onMouseLeave={() => togglePopup(false)}
    >
      {showPopup && popup && (
        <div
          className={styles.popup}
          dangerouslySetInnerHTML={{ __html: popup }}
        />
      )}
      <li>{children}</li>
    </div>
  );
};

export default Footer;
